import Vue from 'vue'
import DateFormat from '@/assets/js/date-format'

Vue.filter('dateFormat', (time) => {
  return DateFormat(time)
})

Vue.filter('goldFormat', (gold = 0) => {
  return String(gold).padStart(3 * Math.ceil((gold).length / 3), '0')
    .replace(/(\d{3})/g, '$1,')
    .replace(/^0+|,$/g, '')
})
